import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';

class PrivacyPolicy extends Component {
  render() {
    return (
      <DocumentMeta extend>
        <h3>Cookie- og privatlivspolitik</h3>

        <h5>Ejeroplysninger</h5>
        <p>
          <a href="https://hashtag.dk/">Hashtag Media ApS</a>
          <br />
          CVR: 43980491
          <br />
          Email: kontakt@sparpenge.dk
        </p>

        <h5>Dette website anvender cookies</h5>
        <p>
          En cookie er en lille tekstfil, der lagres på din computer el.
          tilsvarende for at kunne genkende den. Der er ingen personlige
          oplysninger gemt i vores cookies, og de kan ikke indeholde virus.
        </p>

        <h5>Sådan sletter eller blokerer du for cookies</h5>
        <p>
          <a href="http://minecookies.org/cookiehandtering" target="_blank">
            http://minecookies.org/cookiehandtering
          </a>
        </p>

        <h5>Formål med cookies på vores website</h5>
        <p>
          At gemme dine indstillinger.
          <br />
          Trafikmåling og statistik.
          <br />
          Målretning og frekvensstyring af annoncering.
          <br />
        </p>

        <h5>Tredjeparter med adgang til at sætte cookies</h5>
        <p>Sitet anvender cookies fra en følgende tredjeparter:</p>
        <ul>
          <li>Google.com</li>
          <li>Facebook.com</li>
          <li>Clicky.com</li>
        </ul>

        <h5>Persondata</h5>
        <p>
          Personoplysninger afgives aldrig til tredjepart, med mindre du selv
          udtrykkeligt giver samtykke hertil, og vi indsamler ikke
          personoplysninger, uden at du selv har givet os disse oplysninger ved
          registrering, køb eller deltagelse i en undersøgelse m.v. Du afgiver
          dine personlige oplysninger på eget ansvar. Personoplysninger bruges
          til at gennemføre det køb eller den service, som oplysningerne er
          indsamlet i forbindelse med. I det omfang, der behandles
          personoplysninger om dig, har du ifølge persondataloven ret til at få
          oplyst, hvilke personoplysninger, der kan henføres til dig. Såfremt
          det viser sig, at de oplysninger eller data, der behandles om dig, er
          urigtige eller vildledende, har du ret til at kræve disse berigtiget,
          slettet eller blokeret. Du kan til enhver tid gøre indsigelse mod, at
          oplysninger om dig gøres til genstand for behandling. Du kan også til
          enhver tid tilbagekalde dit samtykke. Du har mulighed for at klage
          over behandlingen af oplysninger og data vedrørende dig. Klage
          indgives til Datatilsynet, jf. persondatalovens § 58, stk. 1.
        </p>
      </DocumentMeta>
    );
  }
}

export default PrivacyPolicy;
